// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"66e4f9c3","455":"b7c502db","977":"c26481b9"}[chunkId] + ".chunk.js";
};